// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/modals.scss
// module id = 246
// module chunks = 6